import PropTypes from 'prop-types';
import * as React from 'react';

import GridDateRangeFilter from './GridDateRangeFilter';

class GridDateOnlyRangeFilter extends GridDateRangeFilter {}

GridDateOnlyRangeFilter.displayName = 'GridDateOnlyRangeFilter';

GridDateOnlyRangeFilter.propTypes = {
  dateOnly: PropTypes.bool,
  colDef: PropTypes.objectOf(PropTypes.any).isRequired,
  filterChangedCallback: PropTypes.func.isRequired,
  filterModifiedCallback: PropTypes.func.isRequired,
  valueGetter: PropTypes.func.isRequired,
};

GridDateOnlyRangeFilter.defaultProps = {
  // override with dateOnly true
  dateOnly: true,
};

export default GridDateOnlyRangeFilter;
